import React from "react";
import clsx from "clsx";

import AppBox from '@/components/AppBox'
import AppText from '@/components/AppText'
import AppButton from '@/components/AppButton'
import AppDropdown from '@/components/AppDropdown'

interface AppPaginationProps {
  totalRows: number;
  rowsPerPage: number;
  currentPage: number;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
  rowsPerPageOptions?: number[];
}

const AppPagination: React.FC<AppPaginationProps> = ({
  totalRows,
  rowsPerPage,
  currentPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [25, 50, 100],
}) => {
  const totalPages = Math.ceil(totalRows / rowsPerPage);

  const handlePreviousPage = () => {
    if (currentPage > 0) onPageChange(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) onPageChange(currentPage + 1);
  };

  const handleRowsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onRowsPerPageChange(Number(e.target.value));
  };

  return (
    <AppBox align="center" justify="end" gap={2} className="px-4 py-3 border-t border-gray-200 bg-white">
      {/* Rows per page */}
      {/* <AppBox align="center" gap={2}>
        <AppText variant="body">Rows per page:</AppText>
        <select
          className="border rounded px-2 py-1 text-gray-700"
          value={rowsPerPage}
          onChange={handleRowsPerPageChange}
        >
          {rowsPerPageOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </AppBox> */}

      {/* Pagination controls */}
      <AppBox className="flex items-center gap-4">
        <AppButton
          onClick={handlePreviousPage}
          disabled={currentPage === 0}
          className={clsx(
            "px-2 py-1 rounded border",
            currentPage === 0
              ? "text-gray-400 cursor-not-allowed"
              : "hover:bg-gray-100 text-gray-700"
          )}
        >
          Previous
        </AppButton>

        <AppText>
          Page&nbsp;<strong>{currentPage + 1}</strong>&nbsp;of&nbsp;<strong>{totalPages}</strong>
        </AppText>

        <AppButton
          onClick={handleNextPage}
          variant="primary"
          disabled={currentPage >= totalPages - 1}
          // className={clsx(
          //   "px-2 py-1 rounded border",
          //   currentPage >= totalPages - 1
          //     ? "text-gray-400 cursor-not-allowed"
          //     : "hover:bg-gray-100 text-gray-700"
          // )}
        >
          Next
        </AppButton>
      </AppBox>

      {/* Total rows */}
      <div>
        <span className="text-gray-700">
          Total: <strong>{totalRows}</strong> rows
        </span>
      </div>
    </AppBox>
  );
};

export default AppPagination;